export const users = {
  description: "حسابات الورشة. لا يمكن للمشغّلين الاطلاع على بيانات الأعمال أو الأموال.",
  addUser: "إضافة مستخدم",
  caption: "مستخدمو الورشة",
  emptyTitle: "لا يوجد مستخدمون",
  emptyDescription: "يُفترض أن تظهر حسابات العرض الأولية هنا.",
  column: {
    user: "المستخدم",
    lastSignIn: "آخر تسجيل دخول",
    manage: "إدارة",
  },
  role: "الدور",
  roleFor: "دور {name}",
  active: "نشط",
  inactive: "غير نشط",
  create: {
    title: "إضافة مستخدم للورشة",
    description:
      "يسجّل الشخص الدخول بهذا البريد الإلكتروني وكلمة المرور الأولية التي تحددها.",
    submit: "إنشاء المستخدم",
    fullName: "الاسم الكامل",
    initialPassword: "كلمة المرور الأولية",
    passwordHint: "10 أحرف على الأقل تتضمن أحرفاً كبيرة وصغيرة ورقماً.",
    createdToast: "تم إنشاء المستخدم",
    createdToastDesc: "يمكن لـ {name} تسجيل الدخول الآن.",
  },
  roleUpdated: "تم تحديث الدور",
  roleUpdatedDesc: "{name} الآن {role}.",
  activatedToast: "تم تفعيل المستخدم",
  deactivatedToast: "تم إيقاف تفعيل المستخدم",
  deactivatedDesc: "أُلغيت جلساتهم المفتوحة.",
  activate: "تفعيل",
  deactivate: "إيقاف التفعيل",
  activateTitle: "تفعيل {name}؟",
  deactivateTitle: "إيقاف تفعيل {name}؟",
  deactivateDescription:
    "يلغي إيقاف التفعيل جميع الجلسات المفتوحة فوراً. ويحتفظ سجل التدقيق بالسبب.",
  reasonHint: "مطلوب (3 أحرف على الأقل).",
};
